
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Welcome",
      function () {
        return require("private-next-pages/Welcome/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Welcome"])
      });
    }
  